<router-outlet></router-outlet>
<div class="cnt-column-centered" style="height: 100%">
    <!-- Header or menu -->
<!--    <div></div>-->
<!--    <scrolldiv style="" [style.width.%]="100" [scrollerSize]="20" [navigatorSize]="14" cls="lightScroll">-->
<!--        <router-outlet></router-outlet>-->
<!--    </scrolldiv>-->


<!--    &lt;!&ndash; SignUp page &ndash;&gt;-->
<!--    <sign-up-root *ngIf="rootPageName === 'sign-up'"></sign-up-root>-->

<!--    &lt;!&ndash; XeroCreation page &ndash;&gt;-->
<!--    <xero-create-root *ngIf="rootPageName === 'xero-create'"></xero-create-root>-->

<!--    &lt;!&ndash; Login page &ndash;&gt;-->
<!--    <login-root *ngIf="rootPageName === 'signIn'" style="width:100%;"></login-root>-->

<!--    &lt;!&ndash; Login page &ndash;&gt;-->
<!--    <reset-password-root *ngIf="rootPageName === 'resetPassword'"></reset-password-root>-->

<!--    <a [routerLink]="['forgottenPassword']">Heroes</a>-->
</div>